/* TinyOops DC runtime — replaces the prototype's support.js.
   Bindings: data-dc-click, data-dc-input, data-dc-text, data-dc-if (on <sc-if>), data-dc-style, data-dc-value.
   Components register themselves on window.__tinyoopsDC as [name, factory(DCLogic)]. */
(function () {
  'use strict';

  class DCLogic {
    constructor(root, props) {
      this.root = root;
      this.props = props || {};
    }
    setState(patch) {
      var p = typeof patch === 'function' ? patch(this.state) : patch;
      this.state = Object.assign({}, this.state, p);
      this.render();
    }
    call(name, e) {
      var fn = this.renderVals()[name];
      if (typeof fn === 'function') fn(e);
    }
    mount() {
      var self = this;
      this.state = this.state || {};
      this.root.querySelectorAll('[data-dc-click]').forEach(function (el) {
        el.addEventListener('click', function (e) { self.call(el.getAttribute('data-dc-click'), e); });
      });
      this.root.querySelectorAll('[data-dc-input]').forEach(function (el) {
        el.addEventListener('input', function (e) { self.call(el.getAttribute('data-dc-input'), e); });
      });
      this.render();
      if (typeof this.componentDidMount === 'function') this.componentDidMount();
      window.addEventListener('pagehide', function () {
        if (typeof self.componentWillUnmount === 'function') self.componentWillUnmount();
      });
    }
    render() {
      var v = this.renderVals();
      this.root.querySelectorAll('[data-dc-text]').forEach(function (el) {
        var val = v[el.getAttribute('data-dc-text')];
        var s = val == null ? '' : String(val);
        if (el.textContent !== s) el.textContent = s;
      });
      this.root.querySelectorAll('[data-dc-if]').forEach(function (el) {
        if (v[el.getAttribute('data-dc-if')]) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
      });
      this.root.querySelectorAll('[data-dc-style]').forEach(function (el) {
        el.getAttribute('data-dc-style').split(';').forEach(function (pair) {
          var i = pair.indexOf('=');
          if (i < 1) return;
          var prop = pair.slice(0, i), key = pair.slice(i + 1);
          el.style.setProperty(prop, String(v[key]));
        });
      });
      this.root.querySelectorAll('[data-dc-value]').forEach(function (el) {
        var val = v[el.getAttribute('data-dc-value')];
        var s = val == null ? '' : String(val);
        if (el.value !== s) el.value = s;
      });
    }
  }

  function boot() {
    var registry = {};
    (window.__tinyoopsDC || []).forEach(function (entry) { registry[entry[0]] = entry[1]; });
    window.__tinyoopsDC = { push: function (entry) { registry[entry[0]] = entry[1]; mountRoots(); } };

    function mountRoots() {
      document.querySelectorAll('[data-dc-root]').forEach(function (root) {
        if (root.__dcMounted) return;
        var factory = registry[root.getAttribute('data-dc-root')];
        if (!factory) return;
        var props = {};
        try { props = JSON.parse(root.getAttribute('data-dc-props') || '{}'); } catch (e) { console.error('TinyOops: bad data-dc-props', e); }
        root.__dcMounted = true;
        var Component = factory(DCLogic);
        try { new Component(root, props).mount(); } catch (e) { console.error('TinyOops: component failed', e); }
      });
    }
    mountRoots();

    // Mobile menu: close on outside click / Escape (from the prototype's head script)
    document.addEventListener('click', function (e) {
      var open = document.querySelectorAll('details.mnav[open]');
      if (!open.length) return;
      var inside = e.target.closest('details.mnav');
      if (!inside || e.target.closest('a')) open.forEach(function (d) { d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('details.mnav[open]').forEach(function (d) { d.removeAttribute('open'); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
